"use client";

import clsx from "clsx";
import {useTranslation} from "react-i18next";
import FrozenStep from "./FrozenStep";
import FrozenValue from "./FrozenValue";
import type {StepChange} from "./diffUseCaseSteps";
import {CHANGE_HIGHLIGHT, isUseCaseStep} from "./useCaseSnapshot";
import {occurrenceKeys, valueKey} from "./snapshotKeys";

interface UseCaseStepListProps {
   items: unknown[];
   changes: StepChange[];
   scriptNames: ReadonlyMap<string, string>;
}

/** One snapshot's complete, ordered steps, each marked with how it changed. */
export default function UseCaseStepList({items, changes, scriptNames}: UseCaseStepListProps) {
   const {t} = useTranslation("ask");
   if (!items.length) return <FrozenValue value={items} />;
   return <ol className="list-decimal space-y-3 pl-5 marker:font-semibold marker:text-500">
      {occurrenceKeys(items, valueKey).map(({key, item}, index) => {
         const {kind, moved} = changes[index];
         return <li key={key} data-change={kind} className={clsx("rounded-md p-2", kind !== "unchanged" && CHANGE_HIGHLIGHT[kind])}>
            {(kind !== "unchanged" || moved) && <div className="mb-1 flex flex-wrap gap-2 text-xs font-semibold text-700">
               {kind !== "unchanged" && <span>{t(`toolApproval.${kind}`)}</span>}
               {moved && <span>{t("toolApproval.moved", moved)}</span>}
            </div>}
            {isUseCaseStep(item) ? <FrozenStep hideId step={item} scriptNames={scriptNames} /> : <FrozenValue value={item} scriptNames={scriptNames} />}
         </li>;
      })}
   </ol>;
}
